import React from 'react'
import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Col, Form, Portlet, Row } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as ActivosFijosInventariosService from 'services/activosFijosInventarios.service'

const portletBreadcrumbs = [{ name: 'Activos Fijos' }, { name: 'Inventarios Físicos' }, { name: 'Nuevo' }]

const initialValues = {
  titulo: '',
  descripcion: '',
  fechaInicio: new Date().toLocaleDateString('es-PE'),
  _idOficina: '',
  oficina: '',
  _idUsuarioResponsable: '',
  responsableNombre: ''
}

const NuevoPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const handleSubmit = async (values, actions) => {
    actions.setSubmitting(true)
    try {
      const { data } = await ActivosFijosInventariosService.nuevo(values)
      __zariContext.snack('success', `Inventario ${data.codigo} creado!`)
      history.push(`/${CodigosTransaccionesConstant.ACTIVOSFIJOS_INVENTARIOS_EDITAR}/${data._id}`)
    } catch (e) {
      __zariContext.snack('error', e?.data?.error || 'Error al crear inventario')
    } finally {
      actions.setSubmitting(false)
    }
  }

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ values, handleChange, handleSubmit, isSubmitting }) => (
        <Portlet>
          <Portlet.Header
            title='Nuevo Inventario Físico'
            breadcrumbs={portletBreadcrumbs}
            buttons={[
              { name: 'Generar Inventario', onClick: handleSubmit, disabled: isSubmitting },
              { name: 'Cancelar', onClick: () => history.push(`/${CodigosTransaccionesConstant.ACTIVOSFIJOS_INVENTARIOS_LISTA}`) }
            ]}
          />
          <Portlet.Body>
            <Row>
              <Col md={8}>
                <Form.Group>
                  <Form.Label text='TÍTULO' md={12} />
                  <Col md={12}>
                    <Form.InputText name='titulo' value={values.titulo} onChange={handleChange} />
                  </Col>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label text='FECHA INICIO' md={12} />
                  <Col md={12}>
                    <Form.InputDate name='fechaInicio' value={values.fechaInicio} onChange={handleChange} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form.Group>
                  <Form.Label text='DESCRIPCIÓN' md={12} />
                  <Col md={12}>
                    <Form.InputText name='descripcion' value={values.descripcion} onChange={handleChange} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Portlet.Body>
        </Portlet>
      )}
    </Formik>
  )
}

export default React.memo(NuevoPage)
